"use client";

import { useState, KeyboardEvent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./faqComponent.css";

interface Faq {
  question: string;
  answer: string;
}

interface FaqComponentProps {
  faqs: Faq[];
}

export default function FaqComponent({ faqs }: FaqComponentProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    if (openIndex === index) {
      // If clicking on already open FAQ, close it
      setOpenIndex(null);
    } else {
      // Close all FAQs first, then open clicked one
      setOpenIndex(index);
    }
  };

  const handleKeyDown = (event: KeyboardEvent, index: number) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleQuestion(index);
    }
  };

  // Don't render if no FAQs
  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <section className="faq-section">
      <div className="section-padding px-0 min-[992px]:py-4 min-[992px]:px-[80px]">
        <div className="section-gap">
          <div className="dedicated-top justify-center">
            <div className="dedicated-text">
              <h2 className="ds-h2 text-center">Frequently Asked Questions</h2>
            </div>
          </div>

          <div className="faq-content">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`single-faq ${openIndex === index ? "active" : ""}`}
                onClick={() => toggleQuestion(index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
                tabIndex={0}
                role="button"
              >
                <div className="flex justify-between items-center w-full">
                  <div className="faq-question">
                    <div
                      className="ds-body-lg"
                      dangerouslySetInnerHTML={{ __html: faq.question }}
                    />
                  </div>
                  <div className="faq-icon">
                    <div className="green-circle">
                      <FontAwesomeIcon icon={faChevronDown} aria-hidden="true" />
                    </div>
                  </div>
                </div>

                <div className="faq-answer" id={`faq-answer-${index}`}>
                  <div
                    className="ds-body-md ff-inter-medium"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
